import React, { useState } from 'react'
import MideaViewer from '../../../midea_viewer/MideaViewer'
import { iconData } from '../../../iconData'

function CrossQueryAttachmentSoft({ key1, attachment, setAttach, delete1 }) {
    const [mideaviewer, setMideaviewer] = useState(false);
    const handleRemoveAttachment = async () => {
        try {
            delete1(key1);
        } catch (error) {
            console.log(error);
        }
    };
    return (
        <>
            <div className="hw_defult_attach_box ml-3">
                <div className="d-flex align-items-center">
                    <div
                        className="d-flex align-items-center p-2"
                        onClick={() => setMideaviewer(!mideaviewer)}
                    >
                        <img
                            className="mr-2 hw_defult_attach_type_icon"
                            style={{ width: "30px", margin: "5px", }}
                            src={`${iconData?.find(
                                (i) =>
                                    i.extension ===
                                    attachment.substring(attachment.lastIndexOf(".") + 1)
                            )?.icon
                                }`}
                            alt="icon"
                        />

                        <span className="hw_default_attach_name">
                            {attachment?.replace(/^[^_]*_/, "")}
                        </span>
                    </div>

                    <img
                        onClick={handleRemoveAttachment}
                        src="/images/attachment_cross_icon.png"
                        alt="icon"
                    />
                </div>
            </div>
            {mideaviewer && (
                <MideaViewer
                    closeMideaviewer={setMideaviewer}
                    attachment={attachment}
                />
            )}
        </>
    )
}

export default CrossQueryAttachmentSoft